import { HttpStatusCode } from 'axios';
import { ApiRequest } from '../../Handlers/ApiReqest';
import { InterActive } from '../../utilities/ViewModelStructure'
import { Account } from '../../Models/Accounts';
import { Notify } from '../../Handlers/Notifications';
import { GeneralMethods } from '../../Handlers/GeneralMethods';
import { AxiosRequest } from '../../Handlers/AxiosHandler';
export class AccountsVM extends InterActive{
    private data:Account[] = [];
    public get Data():Account[]{ return this.data  }
    private set Data(value:Account[]){ this.data = value ; this.update() }

    private newAccount:Account = {id:'' , name: '' , bank_account_id:'',status:'active'};
    public get NewAccount():Account{ return this.newAccount  }
    public set Name(value:string){ this.newAccount.name = value ; this.update()  }
    public set BankAccountId(value:string){ this.newAccount.bank_account_id = value ; this.update()  }

    private currencies:{id:string , arabic_currency_name  :string , english_currency_name:string,status:'active'|'inActive'  }[] = [] ;
    public get Currencies():{id:string , arabic_currency_name :string , english_currency_name:string ,status:'active'|'inActive' }[]{ return this.currencies  }
    private set Currencies(value:{id:string , arabic_currency_name:string , english_currency_name:string,status:'active'|'inActive'  }[]){ this.currencies = value ; this.update()  }

    private changed:number  = 0;
    public get Changed():number{ return this.changed  }
    public set Changed(value:number){ this.changed = value ; this.update()  }

    
    private _status : 'active'|'inActive' = 'active';
    public get status() : 'active'|'inActive' {
        return this._status;
    }
    public set status(v : 'active'|'inActive') {
        this._status = v;
        this.update()
    }
    

    public getData(){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.getCurrenciesAndBankAccounts()
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                this.newAccount = {id:'' , name:'' , bank_account_id:'',status:'active'}
                                this.currencies = response.data.data.currencies
                                this.data = response.data.data.accounts
                                this.update()
                            }
                        } else Notify({type:'danger' , title : 'مشكلة فى الاتصال' , body:'حدثت مشكلة غير متوقعة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }catch{
                    Notify({type:'danger' , title : 'مشكلة فى الاتصال' , body:'حدثت مشكلة غير متوقعة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                }
            }
        )
    }

    public changeName(id:string , newValue:string){
        this.data = this.data?.map(i=>i.id==id?({...i, name:newValue }):(i))
        this.update()
    }

    public changeCurrencyId(id:string , newValue:string){
        this.data = this.data?.map(i=>i.id==id?({...i, bank_account_id:newValue }):(i))
        this.update()
    }

    public sendNew(){
        this.loading(
            async()=>{
                try{
                    if(this.newAccount.name.length == 0){  Notify({type:'danger' , title:'بيانات غير صالحة'  , body:'برجاء ادخال اسم الحساب'});return  }
                    if(this.newAccount.bank_account_id.length == 0){  Notify({type:'danger' , title:'بيانات غير صالحة'  , body:'برجاء اختيار العملة'});return  }

                    const response = await ApiRequest.createAccout(this.newAccount.name , this.newAccount.bank_account_id)
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                this.changed++
                                this.update()
                                Notify({type:'success' , title:'تمت العملية بنجاح', body:'تمت العملية بنجاح'})
                            }else Notify({type:'danger' , title:'فشل العملية', body:response.data.messege})
                        }else Notify({type:'danger' , title:'فشل العملية', body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }                   
                }catch{ Notify({type:'danger' , title:'خطأ'  , body:'مشكلة غير معروفة برجاء .. مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'}) }
            }
        )
    }
    public async edit(data:{id:string , name:string, bank_account_id:string }){
        try{
            if(data.id.length == 0){ 
            Notify({type:'danger' , title:'بيانات غير صالحة'  , body:'برجاء ادخال اسم الحساب'});return  }

            const response = await ApiRequest.updateAccount(data.id , data.name , data.bank_account_id)
            console.log(response)
            if(response){
                if(response.status === HttpStatusCode.Ok){
                    if(response.data.status){
                        Notify({type:'success' , title:'تمت العملية بنجاح', body:'تمت العملية بنجاح'})
                    }else Notify({type:'danger' , title:'فشل العملية', body:response.data.messege})
                }else Notify({type:'danger' , title:'فشل العملية', body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
            }                   
        }catch{ Notify({type:'danger' , title:'خطأ'  , body:'مشكلة غير معروفة برجاء .. مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'}) }

    }

        public changeState(id:string,status:'active'|'inActive'){
            this.loading(async()=>{
                try{
                    let response = await AxiosRequest.statusPost<{id:string, status:'active'|'inActive'}>('changeAccountState',{id:id , status:status})
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(!response.data.status)
                            Notify({type:'danger' , title:'خطأ'  , body:response.data.messege})
                        }else Notify({type:'danger' , title:'خطأ'  , body:'مشكلة غير معروفة برجاء .. مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }
                catch{
                    Notify({type:'danger' , title:'خطأ'  , body:'مشكلة غير معروفة برجاء .. مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                }
                try{
                    const response = await ApiRequest.getCurrenciesAndBankAccounts()
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                this.newAccount = {id:'' , name:'' , bank_account_id:'',status:'active'}
                                this.currencies = response.data.data.currencies
                                this.data = response.data.data.accounts
                            }
                        } else Notify({type:'danger' , title : 'مشكلة فى الاتصال' , body:'حدثت مشكلة غير متوقعة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }catch{
                    Notify({type:'danger' , title : 'مشكلة فى الاتصال' , body:'حدثت مشكلة غير متوقعة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                }                
                this.update()
            })
        }
    
}